import { render, staticRenderFns } from "./CustomDxPopup.vue?vue&type=template&id=ca71ddde&scoped=true&"
import script from "./CustomDxPopup.vue?vue&type=script&lang=js&"
export * from "./CustomDxPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomDxPopup.vue?vue&type=style&index=0&id=ca71ddde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca71ddde",
  null
  
)

export default component.exports